import getPageCustomizableHeaderControls from 'hb-react/shared/apps/PageCustomizables/utils/getPageCustomizableHeaderControls';

const getPageCustomizableHeaderProps = ({
  appPageConfig = {},
  useOldForm,
  controls,
}) => {
  const {
    title,
    menu_name: menuName,
    short_description: shortDescription,
    cover_picture: coverPicture,
    new_cover_picture_normal: coverPictureNormal,
    new_cover_picture_wide: coverPictureWide,
    new_cover_picture_narrow: coverPictureNarrow,
    config = {},
  } = appPageConfig;

  const {
    enable_cover_picture: enableCoverPicture,
    enable_description: enableDescription,
  } = config;

  const { controls: defaultControls } = getPageCustomizableHeaderControls({
    appPageConfig,
  });

  return {
    disableCoverPicture: !enableCoverPicture,
    disableDescription: useOldForm ? false : !enableDescription,
    title: title || menuName,
    description: shortDescription,
    coverPicture: useOldForm ? coverPicture : coverPictureNormal,
    coverPictureWide: useOldForm ? coverPicture : coverPictureWide,
    coverPictureNarrow: useOldForm ? coverPicture : coverPictureNarrow,
    controls: controls ?? defaultControls,
  };
};

export default getPageCustomizableHeaderProps;
